import script from "./HiddenFields.vue?vue&type=script&lang=js"
export * from "./HiddenFields.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__